module.exports = __webpack_public_path__ + "img/462477f.jpg";